import Layout from '@/layout'
export default [
    {
        path: '/user-information',
        component: Layout,
        children: [
            {
                path: '/users-information',
                name: 'Users Information',
                component: () => import('@/views/user-information/index'),
                meta: { title: 'Users Information', icon: 'user' }
            }
        ]
    },
    {
        path: '/user-information/:id',
        component: Layout,
        children: [
            {
                path: '/users-information/:id',
                name: 'UsersInformationDetail',
                component: () => import('@/views/user-information/detail'),
            }
        ]
    },
]